module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight Invoice For Billing - Sea Import")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.proceedAssignmentProforma(
          _vm.ffInvoiceModal.allModuleId,
          0,
          _vm.ffInvoiceModal.jobNo
        )
      }
    }
  }, [_vm._v("Proceed To Proforma")])], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [(_vm.PreviousPerformaList.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body row"
  }, _vm._l((_vm.PreviousPerformaList), function(pre_item, pre_index) {
    return _c('div', {
      key: pre_index,
      staticClass: "col-md-2"
    }, [(pre_item.profarmaSeries) ? _c('b-button', {
      staticClass: "mt-2",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": "info"
      },
      on: {
        "click": function($event) {
          _vm.getPreviousTallyData(pre_item)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(pre_item.profarmaSeries))])]) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Job No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.jobNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "jobNo", $$v)
      },
      expression: "ffInvoiceModal.jobNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.ffInvoiceModal.invoiceStatus),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "invoiceStatus", $$v)
      },
      expression: "ffInvoiceModal.invoiceStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "disabled": "",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.clientName),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "clientName", $$v)
      },
      expression: "ffInvoiceModal.clientName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.adress),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "adress", $$v)
      },
      expression: "ffInvoiceModal.adress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place Of Receipt*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POR),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POR", $$v)
      },
      expression: "ffInvoiceModal.POR"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Load Port*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.LP),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "LP", $$v)
      },
      expression: "ffInvoiceModal.LP"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port Of Discharge*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POD", $$v)
      },
      expression: "ffInvoiceModal.POD"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Place of Delivery*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.FPOD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "FPOD", $$v)
      },
      expression: "ffInvoiceModal.FPOD"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No/ BOE*")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.BOE),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "BOE", $$v)
      },
      expression: "ffInvoiceModal.BOE"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("BL No*")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.blNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "blNo", $$v)
      },
      expression: "ffInvoiceModal.blNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice No.*")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvNo", $$v)
      },
      expression: "ffInvoiceModal.shipperInvNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice Date*")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvDate),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvDate", $$v)
      },
      expression: "ffInvoiceModal.shipperInvDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel/Voy*")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.vessel),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "vessel", $$v)
      },
      expression: "ffInvoiceModal.vessel"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Weight (KGS)*")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.weight),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "weight", $$v)
      },
      expression: "ffInvoiceModal.weight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Line Name*")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shippingLine", $$v)
      },
      expression: "ffInvoiceModal.shippingLine"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Container Details")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-2"
  }, [_c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, _vm._l((_vm.ffInvoiceModal.containerDetails), function(item, index) {
    return _c('b-form-input', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": "",
        "id": "clientRegistrationNo",
        "name": "clientRegistrationNo",
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, _vm._l((_vm.ffInvoiceModal.multipleContainerType), function(item1, index) {
    return _c('b-form-input', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": "",
        "id": "clientRegistrationNo",
        "name": "clientRegistrationNo",
        "value": item1
      }
    })
  }))], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1)], 1), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('Profit-Loss', {
    attrs: {
      "PMS_fk_all_module_id": _vm.ffInvoiceModal.allModuleId,
      "PMS_jb_series": _vm.ffInvoiceModal.jobNo,
      "PMS_fk_client_id": _vm.ffInvoiceModal.clientName,
      "PLAccordianStatus": false,
      "PLAccordianButton": true
    }
  }) : _vm._e(), _vm._v(" "), _c('Assignment-Timeline', {
    attrs: {
      "TMAccordianStatus": false,
      "TMAccordianButton": true,
      "allModuleId": Number(_vm.ffInvoiceModal.allModuleId)
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('Payment-Summary', {
    attrs: {
      "PMS_fk_all_module_id": _vm.ffInvoiceModal.allModuleId,
      "PMS_jb_series": _vm.ffInvoiceModal.jobNo,
      "PMS_fk_client_id": _vm.ffInvoiceModal.clientName
    }
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Charges")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-light table-bordered",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('b-button', {
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": _vm.addQuotationFields
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Currency")]), _vm._v(" "), _c('th', [_vm._v("Quotation Rate")]), _vm._v(" "), _c('th', [_vm._v("Selling Rate")]), _vm._v(" "), _c('th', [_vm._v("Exch Rate")]), _vm._v(" "), _c('th', [_vm._v("Invoice Amount(Without Taxes)")]), _vm._v(" "), _c('th', [_vm._v("Unit")]), _vm._v(" "), _c('th', [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ffTallyInvoiceData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('b-button', {
      attrs: {
        "variant": "danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeCol(index)
        }
      }
    }, [_c('md-icon', [_vm._v("remove")])], 1)], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllLedgerList'],
        "option-value": "ledger",
        "option-text": "ledger",
        "placeholder": "Select Particular"
      },
      model: {
        value: (item.ffType),
        callback: function($$v) {
          _vm.$set(item, "ffType", $$v)
        },
        expression: "item.ffType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.containerMasterData,
        "option-value": "containerType",
        "option-text": "containerType",
        "placeholder": "Select Type"
      },
      model: {
        value: (item.containerType),
        callback: function($$v) {
          _vm.$set(item, "containerType", $$v)
        },
        expression: "item.containerType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.quantity),
        callback: function($$v) {
          _vm.$set(item, "quantity", $$v)
        },
        expression: "item.quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.currencyList,
        "option-value": "currencyV",
        "option-text": "currencyT",
        "placeholder": "Select"
      },
      model: {
        value: (item.currency),
        callback: function($$v) {
          _vm.$set(item, "currency", $$v)
        },
        expression: "item.currency"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": item.ffSellingRate ? true : false
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.ffSellingRate),
        callback: function($$v) {
          _vm.$set(item, "ffSellingRate", $$v)
        },
        expression: "item.ffSellingRate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.sellingRateFinal),
        callback: function($$v) {
          _vm.$set(item, "sellingRateFinal", $$v)
        },
        expression: "item.sellingRateFinal"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.exchRate),
        callback: function($$v) {
          _vm.$set(item, "exchRate", $$v)
        },
        expression: "item.exchRate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.invAmount),
        callback: function($$v) {
          _vm.$set(item, "invAmount", $$v)
        },
        expression: "item.invAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.unitList,
        "option-value": "unitId",
        "option-text": "unitName",
        "placeholder": "Select"
      },
      model: {
        value: (item.unit),
        callback: function($$v) {
          _vm.$set(item, "unit", $$v)
        },
        expression: "item.unit"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    })], 1)])
  }))])])]), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId && _vm.is_noe_validation) ? _c('ExpenseTableComponent', {
    ref: "expenseTableComponent",
    attrs: {
      "show-debug": false,
      "initial-expenses": _vm.initialExpenses,
      "enable-validation": true,
      "allModuleId": _vm.ffInvoiceModal.allModuleId,
      "jobNo": _vm.ffInvoiceModal.jobNo,
      "moduleType": 'FF',
      "transportType": 'Import',
      "branchId": _vm.$sessionsStorage.get('branch_baseLocation'),
      "invoiceStatus": _vm.ffInvoiceModal.invoiceStatus
    },
    on: {
      "expenses-saved": _vm.handleExpensesSaved,
      "expense-validation": _vm.handleExpenseValidation
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('OldExpenseAdditionalTask', {
    attrs: {
      "allModuleId": _vm.ffInvoiceModal.allModuleId,
      "type": 'additional-task'
    }
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": (_vm.DisableSubmit == '0' || _vm.validSubmit == false) &&
        _vm.$store.getters['common/getAllSuccessInvoiceTB']
        .InvoiceTypeKeyFlag == true ?
        true :
        false,
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.submitInvoice('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.ffInvoiceModal.invoiceStatus == "0" ?
    "Save & Send To Billing" :
    "Save & Submit"))]), _vm._v(" "), (_vm.updateTime != 'null' && _vm.editUserName != 'null') ? _c('span', {
    staticStyle: {
      "mmargin-top": "auto",
      "margin-bottom": "auto",
      "padding-top": "20px",
      "margin-left": "20px"
    }
  }, [_vm._v("Last Updated At : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.updateTime))]), _vm._v(" ,\n                  By : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.editUserName))])]) : _vm._e(), _c('br'), _vm._v(" "), (
    _vm.$store.getters['common/getAllSuccessInvoiceTB']
    .BillingSeriesDataString
  ) ? _c('div', [_vm._v("\n                  Invoice No.\n                  "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters["common/getAllSuccessInvoiceTB"]
    .BillingSeriesDataString))]), _vm._v("\n                  genrated.\n                  "), (
    _vm.$store.getters['common/getAllSuccessInvoiceTB']
    .InvoiceTypeKeyFlag == true
  ) ? _c('span', [_vm._v("Cannot be re-submitted")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopMaxPer",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67353427","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/seaImport/freightInvoiceForTallyImport.vue
// module id = 2699
// module chunks = 0